import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { useGameContext } from '../context/GameContext'

const useRoutesControl = ({ loc }: { loc: string }) => {
  const navigate = useNavigate()

  // const [status, _] = useLocalStorage('status', '')

  const {
    passes,
    updatePasses,
    hints,
    updateHints,
    selectRole,
    video,
  } = useGameContext()

  /* ======= path: home || intro || main ======= */

  useEffect(() => {
    if (loc.includes(`stage`)) return

    const ready = !!Object.keys(passes).length
    const toMain = ready && selectRole
    const toEnd = ready && !Object.values(passes).includes(false)
    const toFinal = ready && video

    const onControl = () =>
      toFinal
        ? navigate('/final', { replace: true })
        : toEnd
          ? // 以下待改!
            navigate('/success', { replace: true })
          : toMain
            ? navigate('/main', { replace: true })
            : {}

    onControl()
  }, [loc, passes, navigate])

  /* =========================================== */

  /* ======= path: intro ======= */

  useEffect(() => {
    if (loc !== `intro`) return

    if (!Object.keys(passes).length) {
      updatePasses(draft => {
        draft.stage1 = false
        draft.stage2 = false
        draft.stage3 = false
        draft.stage4 = false
        draft.stage5 = false
        draft.stage6 = false
      })
    }
  }, [loc, passes, updatePasses])

  useEffect(() => {
    if (loc !== `intro`) return

    if (!Object.keys(hints).length) {
      updateHints(draft => {
        draft.stage1 = {}
        draft.stage2 = {}
        draft.stage3 = {}
        draft.stage4 = {}
        draft.stage5 = {}
        draft.stage6 = {}
      })
    }
  }, [loc, hints, updateHints])

  /* =========================== */

  /* ======= path: stage0 - stage5 ======= */

  useEffect(() => {
    if (!loc.includes(`stage`)) return
    const stageId = +loc[5]
    const onStage = (stageId: number) => {
      if (passes[`stage${stageId}`])
        navigate(`/${loc}/ending`, { replace: true })
    }
    onStage(stageId)
  }, [loc, passes, navigate])

  /* ===================================== */

  return null
}

export default useRoutesControl
